import './List.css';
import { useEffect, useState } from 'react';

const List = (props) => {
    const [data, setData] = useState("");
    useEffect(() => {
        setData(props.getData())
    }, [data, props])
    const [selectedText, setselectedText] = useState("")
    return (
        <div className="resourceTextContainer">
            {data?.objects?.map((item, index) => (
                <p key={index} className={`${index === data?.objects?.length - 1 ? 'lastRow' : ''} ${selectedText===item?.resource?.text?.div?"active":""} cursor-pointer list`} onClick={() =>{
                     props.setResourceListData(item)
                     setselectedText(item?.resource?.text?.div)
                     }}>
                    {item?.resource?.text?.div && (
                        <span dangerouslySetInnerHTML={{ __html: item?.resource?.text?.div }}></span>
                    )}
                </p>
            ))}
        </div>
    )
}

export default List;